import script from "./ProjectStakeholders.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectStakeholders.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectStakeholders.vue?vue&type=style&index=0&id=a9f8e148&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f8e148"]])

export default __exports__